module.exports = __webpack_public_path__ + "static/gw_logo-a22c465eddf2305e91f598c882a5f6c2.svg";